<template>
<div class="media-claim-source-wrapper">
    <div class="columns-separator">
        <div class="col left-side-charts">
            <vertical-chart 
                class="chart-item"
                title="By Political Bent"
                sub-title="Where applicable as determined by arbiters independent from Real Clear Media"
                :data="polical_bent_data"
                />

            <vertical-chart 
                class="chart-item"
                title="Satire"
                sub-title="How often do fact-checkers check claims from self-described satire outlets?"
                :data="satire_data"
                />
        </div>
        <div class="col right-side-charts">
            <vertical-chart 
                class="chart-item"
                title="Top Fact-Checked Media"
                sub-title="Top 10 most fact-checked media sources"
                :data="top_fact_checked_data"
                />
        </div>
    </div>
</div>
</template>

<script>

import VerticalChart from '../Charts/VerticalChart.vue';
import ClaimSourcesMixin from './ClaimSourcesMixin.js';

export default {
    name: '',
    components: {
        'vertical-chart': VerticalChart,
    },
    mixins: [
        ClaimSourcesMixin,
    ],
    data() {
        return {
            claim_method: 'claim_source_media',
            polical_bent_data: [],
            top_fact_checked_data: [],
            satire_data: [],
        };
    },
    created(){
        this.getClaimSourceData();
    },
    methods: {
        async getClaimSourceData(){
            let data = await this.getData({}, this.claim_method);
            console.log("CLAIM SOURCE", data);
            this.polical_bent_data      = data.data.data.political_bent_data;
            this.top_fact_checked_data  = data.data.data.top_fact_checked_source_data;
            this.satire_data            = data.data.data.is_satire_data;
        },
    },
}
</script>

<style lang="scss">
.media-claim-source-wrapper{
    .columns-separator{
        display: flex;
        justify-content: space-between;
        .col{
            flex-basis: 50%;
            .chart-item{
                
            }

            &.left-side-charts{
                margin-right: 10px;
                .chart-item{
                
                }
            }

            &.right-side-charts{
                margin-left: 10px;
                .chart-item{
                
                }
            }
        }
    }
}
</style>